import { useLocation } from 'react-router-dom'

export default function useIsInConversationScreen() {
  const location = useLocation()
  const isInConversationScreen = location.pathname.split('/').includes('conversation') || location.pathname.split('/').includes('screenshare')

  return isInConversationScreen
}
